import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface InfoDialogData {
  title: string;
  message: string;
  icon?: string;
  iconColor?: 'primary' | 'accent' | 'warn' | 'error' | 'success';
  buttonText?: string;
  buttonIcon?: string;
}

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {
  title: string;
  message: string;
  icon: string;
  iconColor: string;
  buttonText: string;
  buttonIcon: string;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InfoDialogData
  ) {
    this.title = data.title;
    this.message = data.message;
    this.icon = data.icon || 'info';
    this.iconColor = data.iconColor || 'primary';
    this.buttonText = data.buttonText || 'OK';
    this.buttonIcon = data.buttonIcon || 'check';
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
